import React from "react";
import { useWindowScroll } from "../components/hooks/useWindowScroll";
import { UploadCueSheetsPage, IUploadCueSheetsPageProps } from "./UploadCueSheetsPage";

const UploadCueSheetsPageScrollListener: React.FC<IUploadCueSheetsPageProps> = (props) => {
    const updatedScroll = useWindowScroll();
    return <UploadCueSheetsPage {...props} updatedScroll={updatedScroll} />;
};

export default UploadCueSheetsPageScrollListener;